import { TICKS_PER_BEAT } from '../../shared/tempo';
import type { EnemyDefinition } from '../types';

export interface BlackoutEffect {
  readonly kind: 'blackout';
  readonly everyBars: number;
  readonly bars: number;
}

export const FAUX_CONTACT: EnemyDefinition = {
  id: 'faux-contact',
  name: 'Le Faux contact',
  description: 'Une prise qui grésille, et coupe le son une mesure sur quatre.',
  behaviour: 'boss',
  maxHp: 2000,
  speed: 0.8,
  radius: 44,
  damage: 30,
  attackCooldownTicks: 2 * TICKS_PER_BEAT,
  aggroRadius: 320,
  vibesDrop: 50,
  scalingPerPhrase: { hp: 1, speed: 1 },
  special: { kind: 'blackout', everyBars: 4, bars: 1 },
};
